import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=d4b92a0a&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"
import style0 from "./Token.vue?vue&type=style&index=0&id=d4b92a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b92a0a",
  null
  
)

export default component.exports